var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"id":"dashboard-core-footer","padless":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","md":"auto"}},[_c('div',{staticClass:"caption pt-0 pt-md-0 text-center"},[_vm._v(" Copyright 2025 © Innotech Laboratory Service Co., Ltd. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }